import { render, staticRenderFns } from "./CustomerOrderResponsiveCard.vue?vue&type=template&id=5cb36724&scoped=true"
import script from "./CustomerOrderResponsiveCard.vue?vue&type=script&lang=js"
export * from "./CustomerOrderResponsiveCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderResponsiveCard.vue?vue&type=style&index=0&id=5cb36724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb36724",
  null
  
)

export default component.exports